export default __webpack_public_path__ + "static/media/icn_list_guide_dots.464d49b6.svg";